/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pleaseselectafile3Inputs */

const en_common_pleaseselectafile3 = /** @type {(inputs: Common_Pleaseselectafile3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a file`)
};

/**
* | output |
* | --- |
* | "Please select a file" |
*
* @param {Common_Pleaseselectafile3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_pleaseselectafile3 = /** @type {((inputs?: Common_Pleaseselectafile3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pleaseselectafile3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_pleaseselectafile3(inputs)
});
export { common_pleaseselectafile3 as "common_pleaseSelectAFile" }